// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { LinkedCreditNoteInvoiceFragment } from '../../fragments/generated/linked-credit-note-invoice.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchLinkedCreditNoteInvoiceQueryVariables = Types.Exact<{
  queryInvoiceDTO: Types.QueryInvoiceDtoInput;
}>;


export type SearchLinkedCreditNoteInvoiceQueryResult = { __typename?: 'Query', searchInvoice: Array<{ __typename?: 'InvoiceDTO', id: number }> };

export const SearchLinkedCreditNoteInvoiceGql = gql`
    query SearchLinkedCreditNoteInvoice($queryInvoiceDTO: QueryInvoiceDTOInput!) {
  searchInvoice(queryInvoiceDTO: $queryInvoiceDTO) {
    ...LinkedCreditNoteInvoice
  }
}
    ${LinkedCreditNoteInvoiceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLinkedCreditNoteInvoiceInjectable extends Apollo.Query<SearchLinkedCreditNoteInvoiceQueryResult, SearchLinkedCreditNoteInvoiceQueryVariables> {
    override document = SearchLinkedCreditNoteInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */